import { render } from "./v-tasks-list.vue?vue&type=template&id=168b5a7c"
import script from "./v-tasks-list.vue?vue&type=script&lang=js"
export * from "./v-tasks-list.vue?vue&type=script&lang=js"

import exportComponent from "/builds/simplecrm/simplecrmfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__